export enum IgUsersValuePeriod {
  DAY = 'day',
  WEEK = 'week',
}
